import React from 'react';
import { Link } from 'react-router-dom';
import Logo  from '../images/logo.png'

import { Button } from 'primereact/button';
import { useAuth } from "../hooks/useAuth";

const AppTopbar = (props) => {
	const { logout } = useAuth();
	
	const fncLogOut = () => {
		logout()
	}

	return (
		<div className="layout-topbar">
			<div className="topbar-left">
				<div className="layout-breadcrumb">
					<Link to="/" className="logo">
						<div className="flex align-content-center flex-wrap">
							<div className="logos">
								<img src={Logo} />
							</div>
							<div className="ml-2 logoText flex align-items-center justify-content-center">
								CURRY ROCKEFELLER GROUP
							</div>
						</div>
					</Link>
				</div>
				
			</div>
			<div className="topbar-right">
				<ul className="topbar-menu">
					{process.env.REACT_APP_RESTPATH === 'crgDev' && 
						<li className="ml-2 logoText flex align-items-center justify-content-center">
							DEVELOPMENT
						</li>
					}
					<li>
						<Button type="button" className="links" label="Log Out" onClick={(e) => {fncLogOut()}}></Button>
					</li>
				</ul>
			</div>
		</div>
	);
}

export default AppTopbar;
